import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BackStockProductList from '../entities/back-stockproduct'
import appconst from '@/lib/appconst';


interface BackStockProductState extends ListState<BackStockProductList> {
    stockmodel: BackStockProductList,

}

class BackStockMutations extends ListMutations<BackStockProductList>{

}
class BackStockProduct extends ListModule<BackStockProductState, any, BackStockProductList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackStockProductList>(),
        loading: false,
        stockmodel: BackStockProductList,
        id: 0,
        barcode: "",
    }
    actions = {
        async getAll(context: ActionContext<BackStockProductState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackStockProduct/GetStockProductList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackStockProductList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;

        },
        async SetStockCost(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStockProduct/SetStockCost', payload.data);
        },
        async SettingShelfCost(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStockProduct/SettingShelfCost?id=' + payload.data.id + '&onlyOneShelfCost=' + payload.data.onlyOneShelfCost);
        },
        async CreateStockNum(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/BackStockProduct/CreateStockNum?Id=' + payload.data.id + '&stocknum=' + payload.data.stocknum);
        },
        async EditShelfPosition(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStockProduct/EditShelfPosition', payload.data);
        },
        async EditPreStockNum(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/BackStockProduct/EditPreStockNum?Id=' + payload.data.id + '&prestockNumber=' + payload.data.prestockNumber);
        },
    };
    mutations = {
        setCurrentPage(state: BackStockProductState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackStockProductState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const backstocksproduct = new BackStockProduct();
export default backstocksproduct;